import Spinner from 'react-bootstrap/Spinner';

function Spinners() {
    return (
        <>
            <div className='container bg-white'>
                <Spinner animation="border" />
            </div>
        </>
    )
}

export default Spinners;